// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 216 ? "vendors" : chunkId) + "." + {"216":"231be2905705af664d42","434":"ed6f39e6a30790e3602e"}[chunkId] + ".chunk.js";
};